export default function Marquee({
  items,
  reverse = false,
  duration = 30,
  className = '',
  itemClassName = '',
  separator = '✦',
}: {
  items: Array<string>
  reverse?: boolean
  duration?: number
  className?: string
  itemClassName?: string
  separator?: string
}) {
  return (
    <div className={`preview-marquee ${className}`} aria-hidden="true">
      <div
        className={`preview-marquee-track ${reverse ? 'is-reverse' : ''}`}
        style={{ animationDuration: `${duration}s` }}
      >
        {[0, 1].map((copy) => (
          <div key={copy} className="preview-marquee-copy">
            {items.map((item) => (
              <span
                key={`${copy}-${item}`}
                className={`preview-marquee-item ${itemClassName}`}
              >
                <span>{item}</span>
                <span className="preview-marquee-sep">{separator}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
